import $ from 'jquery';
import _ from 'underscore';
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";

export default function CollateralDetailsTab(wizard) {
	const self = this;
	let elementsMap;
	const els = {};
	const wizardElement = wizard.getWizardElement();
	const namespace = wizardElement.data("namespace").trim();
	const itemObj = wizardElement.data("collateral-existing-item");
	const productObj = wizardElement.data("collateral-existing-product");
	const collateralBarcodedBtnGroupEl = wizardElement.find(".collateral-barcoded-toggler");
  const collateralBarcodedBtnGroup = new QuickBtnGroup(collateralBarcodedBtnGroupEl, {distributeWidth: true});
 	collateralBarcodedBtnGroup.init();

	self.init = function(){
		setMappings();
		setElements();
		fillCollateralData();
  	};

  	function fillCollateralData() {
  		if(itemObj != null && itemObj != "") {
  			els.collateralName.val(itemObj.itmSku);
  			els.collateralDescription.val(productObj.prdName);
  			els.collateralLongDescription.val(productObj.prdDescription);
  			els.collateralType.val(productObj.prdCollateralType);
  			if(productObj.prdBarcodeMarked) {
  				collateralBarcodedBtnGroup.activateBtnViaKey("yes");
  			} else {
  				collateralBarcodedBtnGroup.activateBtnViaKey("no");
  			}
  			els.collateralUPC.val(itemObj.itmUpc);
  			els.collateralLength.val(itemObj.itmDimnLength);
  			els.collateralWidth.val(itemObj.itmDimnWidth);
  			els.collateralHeight.val(itemObj.itmDimnHeight);
  			els.collateralWeight.val(itemObj.itmDimnWeight);
        els.hiddenItemId.val(itemObj.itmId);
        els.hiddenPrdId.val(productObj.prdId);
        if(productObj.prdHandlingInstr === "Y") {
          els.excludePkgProducts.prop('checked', true);
        }
  		}
  	}

  function setMappings() {
	elementsMap = {
      collateralName: `#${namespace}collateralName`,
      collateralDescription : `#${namespace}collateralDescription`,
      collateralLongDescription : `#${namespace}collateralLongDescription`,
      collateralType : `#${namespace}collateralType`,
      collateralBarcoded : `#${namespace}collateralBarcoded`,
      collateralUPC : `#${namespace}collateralUPC`,
      collateralLength : `#${namespace}collateralLength`,
      collateralWidth : `#${namespace}collateralWidth`,
      collateralHeight : `#${namespace}collateralHeight`,
      collateralWeight : `#${namespace}collateralWeight`,
      excludePkgProducts : `#excludePrepackagedProducts`,
      hiddenItemId : `#collateral-itemId`,
      hiddenPrdId : `#collateral-prdId`
    };
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setElementsFromScope(targetObj, elementsDict, scope){
    _(elementsDict).each((v, k)=>{
      targetObj[k] = scope.find(v);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/CollateralDetailsTab.js